<script>
import Modal from "@/components/_Shared/Modal/Index";
import Tip from "@/components/_base/Tip";

export default {
  components: {
    Modal,
    Tip
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <div class="header-text">Cancelar oferta de limpeza</div>
    </template>

    <template slot="body">
      <Tip >
        Não é possível editar as informações da limpeza após a oferta ter sido criada. Você pode cancelar essa oferta, editar os filtros e criar uma nova oferta.
      </Tip>
    </template>

    <template slot="footer">
      <button class="btn bg-purple" @click="$emit('cancelOrderOffer')">
        <span>cancelar oferta e editar filtros</span>
      </button>

      <button class="btn bg-outlined" @click="$emit('closeCancelOrderOfferModal')">
        <span>voltar</span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.header-text {
  width: 100%;
  padding-bottom: 8px;
  text-align: center;
  font-weight: 400;
  border-bottom: solid 1px #e2e2e2;
}

.city {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #424242;
}

.city > .name {
  font-weight: 500;
  margin-bottom: 4px;
}

.city > .district {
  font-weight: 400;
}

.body-content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
}

.body-content img {
  width: 14px;
  margin-right: 4px;
}

.date,
.duration,
.location {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
}

button {
  margin: 0;
  margin-top: 8px;
}

.bg-outlined {
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalOfferList/CancelOrderOffer.vue